//Effects
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  CREATE_JOB_DOCUMENT,
  CREATE_JOB_DOCUMENT_FAILURE,
  CREATE_JOB_DOCUMENT_SUCCESS,
  CREATE_SUBTASK,
  CREATE_SUBTASK_FAILURE,
  CREATE_SUBTASK_SUCCESS,
  DELETE_JOB,
  DELETE_JOB_DOCUMENT,
  DELETE_JOB_DOCUMENT_FAILURE,
  DELETE_JOB_DOCUMENT_SUCCESS,
  DELETE_JOB_FAILURE,
  DELETE_JOB_SUCCESS,
  DELETE_SUBTASK,
  DELETE_SUBTASK_FAILURE,
  DELETE_SUBTASK_SUCCESS,
  EXPORT_JOB_REPORT,
  EXPORT_JOB_REPORT_FAILURE,
  EXPORT_JOB_REPORT_SUCCESS,
  GET_JOBS_LIST,
  GET_JOBS_LIST_FAILURE,
  GET_JOBS_LIST_SUCCESS,
  GET_JOBS_SHORT_LIST,
  GET_JOBS_SHORT_LIST_FAILURE,
  GET_JOBS_SHORT_LIST_SUCCESS,
  GET_JOB_DETAILS,
  GET_JOB_DETAILS_FAILURE,
  GET_JOB_DETAILS_SUCCESS,
  GET_JOB_DOCUMENTS_LIST,
  GET_JOB_DOCUMENTS_LIST_FAILURE,
  GET_JOB_DOCUMENTS_LIST_SUCCESS,
  GET_SUBTASKS,
  GET_SUBTASKS_FAILURE,
  GET_SUBTASKS_SUCCESS,
  JOB_ASSIGNEE_ADD,
  JOB_ASSIGNEE_ADD_FAILURE,
  JOB_ASSIGNEE_ADD_SUCCESS,
  JOB_ASSIGNEE_REMOVE,
  JOB_ASSIGNEE_REMOVE_FAILURE,
  JOB_ASSIGNEE_REMOVE_SUCCESS,
  UPDATE_JOB_STATUS,
  UPDATE_JOB_STATUS_FAILURE,
  UPDATE_JOB_STATUS_SUCCESS,
  UPDATE_SUBTASK,
  UPDATE_SUBTASK_FAILURE,
  UPDATE_SUBTASK_SUCCESS,
} from "../../modules/constants";
//Service
import { defaultApi } from "../../utils/axiosApi";

export function* handleGetjobsList({ payload }) {
  try {
    const {
      organization_id,
      paginate,
      start_date,
      end_date,
      page,
      assignee_id,
      job_name,
      status,
      work_order_id,
      approval_status,
      client_id,
    } = payload;
    const queryParams = [];
    if (paginate) queryParams.push(`paginate=${paginate}`);
    if (start_date) queryParams.push(`start_time=${start_date}`);
    if (end_date) queryParams.push(`end_time=${end_date}`);
    if (assignee_id) queryParams.push(`assignee_id=${assignee_id}`);
    if (page) queryParams.push(`page=${page}`);
    if (job_name) queryParams.push(`name=${job_name}`);
    if (status) queryParams.push(`status=${status}`);
    if (work_order_id) queryParams.push(`work_order_id=${work_order_id}`);
    if (approval_status) queryParams.push(`approval_status=${approval_status}`);
    if (client_id) queryParams.push(`client_id=${client_id}`);
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
    const url = `${organization_id}/workorder/jobs${queryString}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_JOBS_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_JOBS_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleJobApproval({ payload }) {
  const { organization_id, job_id, approval_id, details, orgType } = payload;
  try {
    const url = `${organization_id}/jobs/${job_id}/approval/${approval_id}/`;
    const method = "PUT";
    const response = yield defaultApi(url, method, details);
    yield put({
      type: UPDATE_JOB_STATUS_SUCCESS,
      payload: { ...payload, data: response, job_id },
    });
  } catch (err) {
    yield put({
      type: UPDATE_JOB_STATUS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetjobsShortList({ payload }) {
  try {
    const { organization_id, type } = payload;
    let url = `${organization_id}/workorder/jobs/all/short/${
      type === "scheduled"
        ? `?status=ready to dispatch`
        : type === "unscheduled"
        ? `?status=unscheduled`
        : ``
    }`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_JOBS_SHORT_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_JOBS_SHORT_LIST_FAILURE,
      payload: err,
    });
  }
}
export function* handleGetJobDetails({ payload }) {
  try {
    const { organization_id, workOrder_id, job_id } = payload;
    const url = `${organization_id}/workorder/${workOrder_id}/job_with_schedule-v2/${job_id}`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_JOB_DETAILS_SUCCESS,
      payload: { data: response, notify: method },
    });
  } catch (err) {
    yield put({
      type: GET_JOB_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* removeJobAssigneeRequest({ payload }) {
  try {
    let { organization_id, workOrder_id, job_id, user_id } = payload;
    let url = `${organization_id}/workorder/${workOrder_id}/jobs/${job_id}/assignees/${user_id}`;
    let method = "DELETE";
    const response = yield defaultApi(url, method);
    yield put({
      type: JOB_ASSIGNEE_REMOVE_SUCCESS,
      payload: {
        data: response,
        notify: "DELETE",
      },
      userData: { userId: user_id },
    });
  } catch (err) {
    yield put({
      type: JOB_ASSIGNEE_REMOVE_FAILURE,
      payload: err,
    });
  }
}

export function* addJobAssigneeRequest({ payload }) {
  try {
    let { organization_id, workOrder_id, job_id, ...user_id } = payload;
    let url = `${organization_id}/workorder/${workOrder_id}/jobs/${job_id}/assignees/`;
    let method = "POST";
    const response = yield defaultApi(url, method, user_id);

    yield put({
      type: JOB_ASSIGNEE_ADD_SUCCESS,
      payload: { data: response, notify: "POST" },
    });
  } catch (err) {
    yield put({
      type: JOB_ASSIGNEE_ADD_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteJob({ payload }) {
  try {
    const { organization_id, workOrder_id, job_id ,orgType} = payload;
    let url = `${organization_id}/workorder/${workOrder_id}/jobs/${job_id}/`;
    let method = "DELETE";
    const response = yield defaultApi(url, method);
    yield put({
      type: DELETE_JOB_SUCCESS,
      payload: { ...payload, data: response, job_id, notify: method },
    });
  } catch (err) {
    yield put({
      type: DELETE_JOB_FAILURE,
      payload: err,
    });
  }
}

export function* handleExportJobReportRequest({ payload }) {
  try {
    const {
      organization_id,
      start_date,
      end_date,
      work_order_id,
      assignee_id,
      status,
      selectedOrganization,
    } = payload;

    let url = `${organization_id}/workorder/jobs/export/?${
      start_date ? `&start_time=${start_date}` : ""
    }${end_date ? `&end_time=${end_date}` : ""}${
      work_order_id ? `&work_order_id=${work_order_id}` : ""
    }${assignee_id ? `&assignee_id=${assignee_id}` : ""}${
      status ? `&approval__status=${status}` : ""
    }`;

    const response = yield defaultApi(url, "GET");

    yield put({
      type: EXPORT_JOB_REPORT_SUCCESS,
      payload: { data: response, start_date, end_date, selectedOrganization },
    });
  } catch (err) {
    yield put({
      type: EXPORT_JOB_REPORT_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetSubtasks({ payload }) {
  try {
    const { organization_id, work_order_id, job_id } = payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/sub-task/`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_SUBTASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_SUBTASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateSubtask({ payload }) {
  try {
    const { organization_id, work_order_id, job_id, data, orgType } = payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/sub-task/`;
    let method = "POST";
    const response = yield defaultApi(url, method, data);
    yield put({
      type: CREATE_SUBTASK_SUCCESS,
      payload: { data: response, orgType: orgType },
    });
  } catch (err) {
    yield put({
      type: CREATE_SUBTASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleUpdateSubtask({ payload }) {
  try {
    const {
      organization_id,
      work_order_id,
      job_id,
      subtask_id,
      data,
      orgType,
    } = payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/sub-task/${subtask_id}/`;
    let method = "PATCH";
    const response = yield defaultApi(url, method, data);
    yield put({
      type: UPDATE_SUBTASK_SUCCESS,
      payload: { data: response, orgType: orgType },
    });
  } catch (err) {
    yield put({
      type: UPDATE_SUBTASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteSubtask({ payload }) {
  try {
    const { organization_id, work_order_id, job_id, subtask_id, orgType } =
      payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/sub-task/${subtask_id}/`;
    let method = "DELETE";
    yield defaultApi(url, method);
    yield put({
      type: DELETE_SUBTASK_SUCCESS,
      payload: { subtaskId: subtask_id, orgType: orgType },
    });
  } catch (err) {
    yield put({
      type: DELETE_SUBTASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetJobDocuments({ payload }) {
  try {
    const { organization_id, work_order_id, job_id } = payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/documents/`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_JOB_DOCUMENTS_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_JOB_DOCUMENTS_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateJobDocument({ payload }) {
  try {
    const {
      organization_id,
      work_order_id,
      job_id,
      data,
      suppressSuccessNotification,
    } = payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/documents/`;
    let method = "POST";
    // Pass FormData directly to API - do not JSON stringify
    const response = yield defaultApi(url, method, data);
    yield put({
      type: CREATE_JOB_DOCUMENT_SUCCESS,
      payload: { data: response, suppressSuccessNotification },
    });
  } catch (err) {
    yield put({
      type: CREATE_JOB_DOCUMENT_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteJobDocument({ payload }) {
  try {
    const { organization_id, work_order_id, job_id, document_id } = payload;
    let url = `${organization_id}/workorder/jobs/${job_id}/documents/${document_id}/`;
    let method = "DELETE";
    yield defaultApi(url, method);
    yield put({
      type: DELETE_JOB_DOCUMENT_SUCCESS,
      payload: { document_id },
    });
  } catch (err) {
    yield put({
      type: DELETE_JOB_DOCUMENT_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(GET_JOBS_LIST, handleGetjobsList),
    takeLatest(GET_JOBS_SHORT_LIST, handleGetjobsShortList),
    takeLatest(GET_JOB_DETAILS, handleGetJobDetails),
    takeLatest(JOB_ASSIGNEE_REMOVE, removeJobAssigneeRequest),
    takeLatest(JOB_ASSIGNEE_ADD, addJobAssigneeRequest),
    takeLatest(DELETE_JOB, handleDeleteJob),
    takeLatest(UPDATE_JOB_STATUS, handleJobApproval),
    takeLatest(EXPORT_JOB_REPORT, handleExportJobReportRequest),
    takeLatest(GET_SUBTASKS, handleGetSubtasks),
    takeLatest(CREATE_SUBTASK, handleCreateSubtask),
    takeLatest(UPDATE_SUBTASK, handleUpdateSubtask),
    takeLatest(DELETE_SUBTASK, handleDeleteSubtask),
    // Job Documents Watchers
    takeLatest(GET_JOB_DOCUMENTS_LIST, handleGetJobDocuments),
    takeLatest(CREATE_JOB_DOCUMENT, handleCreateJobDocument),
    takeLatest(DELETE_JOB_DOCUMENT, handleDeleteJobDocument),
  ]);
}
